import styled from "@emotion/styled";
import { InputAlign } from "@skbkontur/react-ui";

import { FlexBoxAlign } from "../Input/Input.styles";

export const ReadOnlyAlignFxInput = styled.div<{ align: InputAlign | undefined; autoFlag?: boolean }>(props => ({
    display: "flex",
    width: "100%",
    margin: "0 2px 0 2px",
    justifyContent: alignConverter(props.align, props.autoFlag),
}));

const alignConverter = (align: InputAlign | undefined, autoFlag?: boolean): FlexBoxAlign => {
    if (autoFlag || align === "right") {
        return "flex-end";
    }
    if (align === "left") {
        return "flex-start";
    }
    if (align === "center") {
        return "center";
    }
    return "flex-end";
};
